import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tabs-block-wrap" }
const _hoisted_2 = { class: "tabs-block" }

import {ref} from "vue";
import {useLocalizationStore} from "@/shared";


export default /*#__PURE__*/_defineComponent({
  __name: 'tabs-block',
  setup(__props) {


const {translate} = useLocalizationStore();
const tab = ref();

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs, {
            modelValue: tab.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
            "fixed-tabs": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tab, { value: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)('services_solutions')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_tab, { value: 2 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)('terminal_solutions')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_tab, { value: 3 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)('documentation_consulting')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_window, {
            modelValue: tab.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, { fluid: "" }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "services_solutions")
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              }),
              _createVNode(_component_v_window_item, { value: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, { fluid: "" }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "terminal_solutions")
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              }),
              _createVNode(_component_v_window_item, { value: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, { fluid: "" }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "documentation_consulting")
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              })
            ]),
            _: 3
          }, 8, ["modelValue"])
        ]),
        _: 3
      })
    ])
  ]))
}
}

})